import React from 'react';
import {
    isNil,
    join,
    makeArray,
    map,
    MemberField,
    MemberFieldValueType,
    parseDate,
    pick,
    SEP,
    size,
    transformDayjsFormat
} from '@libs/shared';
import { useConfigProvider } from '~/hooks';
import { getDepartmentName } from '~/utils';
import { MemberName } from '@fx-ui/platform-sdk';

interface MemberFieldViewProps {
    field: MemberField;
    value?: any;
}

const MemberFieldView: React.FC<MemberFieldViewProps> = (props) => {
    const { field, value } = props;

    const { timezone } = useConfigProvider();

    switch (field.valueType) {
        case MemberFieldValueType.Datetime: {
            const date = parseDate(value, timezone);
            const fmt = transformDayjsFormat(field.format || 'yyyy-MM-dd');
            return isNil(date) ? '' : date.format(fmt);
        }
        case MemberFieldValueType.User:
        case MemberFieldValueType.UserGroup: {
            const valueList = makeArray(value);
            return (
                <>
                    {map(valueList, (item, index) => {
                        const isLast = index + 1 === size(valueList);
                        return (
                            <React.Fragment key={index}>
                                <MemberName
                                    name={item.nickname ?? ''}
                                    {...pick(item, ['status', 'type'])}
                                />
                                {!isLast && <span>{SEP.COMMA}</span>}
                            </React.Fragment>
                        );
                    })}
                </>
            );
        }
        case MemberFieldValueType.Dept:
        case MemberFieldValueType.DeptGroup:
            return join(map(makeArray(value), getDepartmentName), SEP.COMMA);
        case MemberFieldValueType.Combo:
        case MemberFieldValueType.ComboCheck:
            return join(makeArray(value), SEP.COMMA);
        case MemberFieldValueType.Text:
        case MemberFieldValueType.Number:
        default:
            return value ?? '';
    }
};

export default MemberFieldView;
